
import { defineComponent } from '@nuxtjs/composition-api';
import { breakpoint } from '~/composables/breakpoint';

export default defineComponent({
  name: 'ProductBenefitsSection',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const { isBiggerThanBreakpoint } = breakpoint('lg');

    const cutInformationBlock = (index, length) => {
      if (index === 0) {
        return 'left';
      }

      if (index === length - 1 && index % 2 && isBiggerThanBreakpoint.value) {
        return 'right';
      }

      return null;
    };

    const cutImageBlock = (index, length) => {
      if (!isBiggerThanBreakpoint.value && index === length - 1) {
        return 'right';
      }

      if (index === length - 1 && !(index % 2)) {
        return 'right';
      }

      return null;
    };

    return {
      cutInformationBlock,
      cutImageBlock,
    };
  },
});
